export class DonationConfirmModel {
  received_amount: number = 0;
  payment_receipt?: string = null;
  payment_method: string = null;
  pledging_status: string = null;
  transaction_id: string = null;
  admin_id: string = null;

  constructor(obj?: Partial<DonationConfirmModel>) {
    if (obj) {
      this.update(obj);
    }
  }
  
  update(obj: Partial<DonationConfirmModel>) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] !== undefined) {
        this[key] = obj[key];
      }
    });
  }
  //   constructor(obj?: any) {
  //     if (obj) {
  //       Object.keys(this).forEach((key) => {
  //         if (obj.hasOwnProperty(key)) {
  //           this[key] = obj[key];
  //         }
  //       });
  //     }
  //   }
}
